import { render } from "./Navbar-item.vue?vue&type=template&id=297b4386&scoped=true"
import script from "./Navbar-item.vue?vue&type=script&lang=js"
export * from "./Navbar-item.vue?vue&type=script&lang=js"

import "./Navbar-item.vue?vue&type=style&index=0&id=297b4386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297b4386"]])

export default __exports__